function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { ExternalTrackingExeption } from 'internals/exceptionHandler';
import { getFileName, filterPropertiesByPatterns } from 'internals/helpers';
import amplitude from 'domains/trackingModules/amplitude/lib';
import GeneralEventTrackingDispatcher from '../GeneralEventTrackingDispatcher';
import { OMITTED_PROPERTY_PATTERNS } from '../../constants';
var snowplowTracker;
var SnowplowEventDispatcher = /*#__PURE__*/function (_GeneralEventTracking) {
  /*
  * This class is an interface for connecting to Snowplow SDK.
  * It is responsible for encapsulating all snowplow SDK calls, and exposing general event to the application.
  * Always use the factory getSnowplowEventDispatcherInstance to instantiate this class.
  */
  function SnowplowEventDispatcher(_ref) {
    var _this;
    var userFetcher = _ref.userFetcher;
    _classCallCheck(this, SnowplowEventDispatcher);
    _this = _callSuper(this, SnowplowEventDispatcher, [{
      userFetcher: userFetcher
    }]);
    _this.isTrackerConfigured = false;
    return _this;
  }
  _inherits(SnowplowEventDispatcher, _GeneralEventTracking);
  return _createClass(SnowplowEventDispatcher, [{
    key: "configureTracker",
    value: function configureTracker() {
      if (!this.isTrackerEnabled()) {
        // eslint-disable-next-line no-console
        console.warn('Unable to configure Snowplow tracker: window is unavailable or does not provide snowplow');
        return;
      }
      if (!process.env.SNOWPLOW_APP_ID) {
        throw new Error('No Snowplow app id set.');
      }
      if (!process.env.SNOWPLOW_DOMAIN) {
        throw new Error('No Snowplow domain set.');
      }
      try {
        this.amplitudeInstance = amplitude.getInstance();
        this.sessionId = this.amplitudeInstance.getSessionId();
        window.snowplow('newTracker', 'cf', process.env.SNOWPLOW_DOMAIN, {
          appId: process.env.SNOWPLOW_APP_ID,
          forceSecureTracker: true,
          platform: 'web'
        });
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error configuring tracker: ".concat(e),
          fileName: getFileName(__filename),
          externalTrackingService: 'Snowplow'
        });
      }
      this.isTrackerConfigured = true;
    }
  }, {
    key: "isTrackerEnabled",
    value: function isTrackerEnabled() {
      return window && window.snowplow;
    }
  }, {
    key: "setUserProperties",
    value: function setUserProperties(payload) {
      var fetchUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.isTrackerEnabled()) {
        return;
      }
      if (!this.isTrackerConfigured) {
        this.configureTracker();
      }
      try {
        if (!payload) {
          this.setDefaultUserProperties();
          return;
        }
        if (fetchUser) {
          this.user = this.validUserFetcher();
        }
        this.userProperties = Object.assign({}, this.userProperties, filterPropertiesByPatterns(payload, OMITTED_PROPERTY_PATTERNS.snowplow));
        window.snowplow('setUserId', this.user.user_id);
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error on setUserProperties: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          externalTrackingService: 'Snowplow',
          extra: {
            payload: payload
          }
        });
      }
    }
  }, {
    key: "setDefaultUserProperties",
    value: function setDefaultUserProperties() {
      var fetchUser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.isTrackerEnabled()) {
        return;
      }
      if (!this.isTrackerConfigured) {
        this.configureTracker();
      }
      try {
        if (fetchUser) {
          this.user = this.validUserFetcher();
        }
        window.snowplow('setUserId', this.user.user_id);
        this.userProperties = {
          login_status: this.user.login_status,
          platform: 'web',
          amplitude_session_id: this.sessionId,
          amplitude_device_id: this.amplitudeInstance.options.deviceId,
          web_mobile_mode: this.webMobileMode
        };
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error on setDefaultUserProperties: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          externalTrackingService: 'Snowplow'
        });
      }
    }
  }, {
    key: "logWithDefaultEventProps",
    value: function logWithDefaultEventProps(eventName, state, extraProperties) {
      if (!this.isTrackerEnabled()) {
        return;
      }
      if (!this.isTrackerConfigured) {
        this.configureTracker();
      }
      if (!extraProperties.snowplow_schema) {
        throw new Error('Did not receive Snowplow schema for event.');
      }
      try {
        var eventProps = {};
        Object.assign(eventProps, this.createMainEventProperties(state));
        Object.assign(eventProps, extraProperties);
        window.snowplow('trackSelfDescribingEvent', {
          schema: extraProperties.snowplow_schema,
          data: {
            event_name: eventName,
            user: this.userProperties,
            event: eventProps
          }
        });
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error on logWithDefaultEventProps: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          externalTrackingService: 'Snowplow'
        });
      }
    }
  }, {
    key: "logWithDefaultProps",
    value: function logWithDefaultProps(eventName, state, extraProperties) {
      if (!this.isTrackerEnabled()) {
        return;
      }
      if (!this.isTrackerConfigured) {
        this.configureTracker();
      }
      var fetchUser = eventName.includes('login');
      this.setDefaultUserProperties(fetchUser);
      this.logWithDefaultEventProps(eventName, state, extraProperties);
    }
  }, {
    key: "identify",
    value: function identify() {
      // eslint-disable-next-line no-console
      console.warn('identify not implemented');
    }
  }]);
}(GeneralEventTrackingDispatcher);
var getSnowplowEventDispatcherInstance = function getSnowplowEventDispatcherInstance(userFetcher) {
  /*
  * Factory responsible for generating a singleton. Only one instance of EventDispatcherHandler must exist at a time.
  */
  if (snowplowTracker) {
    return snowplowTracker;
  }
  snowplowTracker = new SnowplowEventDispatcher({
    userFetcher: userFetcher
  });
  return snowplowTracker;
};
export { SnowplowEventDispatcher };
export default getSnowplowEventDispatcherInstance;